import MediumText from '@/components/MediumText';
import CustomCard from '@/components/customCard';
import ActiveApp from '@/pages/Home/components/Checklist/Components/ActiveApp';
import AutoDetectLocation from '@/pages/Home/components/Checklist/Components/AutoDetectLocation';
import CreateGeneralRule from '@/pages/Home/components/Checklist/Components/CreateGeneralRule';
import EmbedApp from '@/pages/Home/components/Checklist/Components/EmbedApp';
import { ChecklistStyled } from '@/pages/Home/components/Checklist/styled';
import sessionSlice, { isShowBannerSelector } from '@/redux/slice/session.slice';
import { Button } from '@shopify/polaris';
import { XIcon } from '@shopify/polaris-icons';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function Checklist() {
  const { isVisibleSetupChecklist } = useSelector(isShowBannerSelector);
  const dispatch = useDispatch();

  if (!isVisibleSetupChecklist) return null;
  return (
    <ChecklistStyled>
      <CustomCard
        title={'Setup checklist'}
        titleContentRight={
          <Button
            variant="tertiary"
            icon={XIcon}
            onClick={() => dispatch(sessionSlice.actions.handleBanner({ key: 'isVisibleSetupChecklist', value: false }))}
          />
        }
      >
        <MediumText>Best practices to set up delivery estimates for your store.</MediumText>
        <div className="mt-8 card-wrapper">
          <ActiveApp />
        </div>
        <div className="mt-8 card-wrapper">
          <EmbedApp />
        </div>
        <div className="mt-8 card-wrapper card-flex-column">
          <CreateGeneralRule />
        </div>
        {/* <div className="mt-8 card-wrapper card-flex-column">
          <Appearance />
        </div> */}
        {/* <div className="mt-8 card-wrapper card-flex-column">
          <ShowInCart />
        </div> */}
        <div className="mt-8 card-wrapper card-flex-column">
          <AutoDetectLocation />
        </div>
      </CustomCard>
    </ChecklistStyled>
  );
}

export default memo(Checklist);
